import React from 'react';
import { ZdsInputSearch } from '@zig-design-system/ui-components-react';
import { renderToString } from 'react-dom/server';
import Translation from '../../../../Shared/components/Translation';
const TextFilter = ({ filter, handleFilterChange, activeFilters }) => {
    var _a, _b;
    return (React.createElement("div", { id: filter.field },
        React.createElement(ZdsInputSearch, { label: renderToString(React.createElement(Translation, { item: filter.label, asString: true })), onZdsSearch: handleFilterChange, value: (_b = (_a = activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.userFilters) === null || _a === void 0 ? void 0 : _a[filter.field]) !== null && _b !== void 0 ? _b : '' })));
};
export default TextFilter;
